import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import LoadingOverlay from '../../../shared/components/LoadingOverlay';
import departmentSettingsActionsCreators from '../../store/department-settings/action-creators/index';
import departmentSettingsSelectors from '../../store/department-settings/selectors';
import EditActionButton from '../common/EditActionButton';
import ListActionSubheader from '../common/ListActionSubheader';
import FormattedProperty from '../common/FormattedProperty';
import DepartmentSettingsEdit from './DepartmentSettingsEdit';
import NotificationDetail from './NotificationDetail';
import NotificationEdit from './NotificationEdit';
import Modal from "../../../shared/ui/Modal";
import './DepartmentSettings.scss';
import {Card} from "reactstrap";
import UploadFTOGuidelines from "./UploadFTOGuidelines";
import CustomForm from "../../../shared/components/form/CustomForm";
import {MainDepartmentNameForm, RolesSettingsForm} from "../../../shared/components/form/RolesSettingsConfig";
import AddActionButton from "../common/AddActionButton";
import Checkbox from "../../../shared/forms/Checkbox";
import commonActionCreators from "../../../shared/store/common/action-creators";
import Select from '../../../shared/ui/Select';
import UploadBadge from './UploadBadge';

class DepartmentSettings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isEditingRatings: false,
      newTaskResponse: '',
      newOitTaskResponse: '',
      newShift: ''
    };
  }

  // ----------------------
  // Lifecycle
  // ----------------------

  componentWillMount() {
    this.props.loadDepartmentSettings();
  }

  componentDidMount() {
    this.props.fetchFormTypes();
  }


  // ----------------------
  // Handlers
  // ----------------------

  get taskResponses() {
    return this.props.settings.taskResponses || []
  }

  get oitTaskResponses() {
    return this.props.settings.oitTaskResponses || []
  }

  get shifts() {
    return this.props.settings.shifts || []
  }

  onCloseEditRatings() {
    this.setState({isEditingRatings: false});
  }

  onEditRatings() {
    this.setState({isEditingRatings: true});
  }

  onSaveEditRatings(ratingsFormData) {
    this.props.updateDepartmentSettings({
      settings: {
        ...this.props.settings,
        ...ratingsFormData
      }
    })
      .then(() => {
        this.onCloseEditRatings();
      });
  }

  onSaveEditNotificationDetails(notificationFormData) {
    this.props.updateNotification(this.props.selectedNotificationGuid, notificationFormData)
      .then(() => {
        this.props.closeEditNotification();
      });
  }

  // ----------------------
  // Computed
  // ----------------------

  get isLoading() {
    return this.props.isLoading.includes('fetchDepartmentSettings')
      || !this.props.settings;
  }

  get isNotificationDistributionLoading() {
    return this.props.isLoading.includes('updateDistribution')
  }

  get isEditNotificationLoading() {
    return this.props.isLoading.includes('updateNotification');
  }

  get isDepartmentSettingsEditLoading() {
    return this.props.isLoading.includes('updateDepartmentSettings')
  }

  get isShowingNotification() {
    return this.props.selectedNotification;
  }

  get rolesSettings() {
    return this.props.settings.rolesSettings || {}
  }

  get formTypes() {

    return this.props.formTypes.reduce((acc, {short: formType}) => {

      const isAdded = this.critiqueFormTypes.find((cformType) => cformType === formType);

      if (isAdded) {
        return [
          ...acc
        ]
      }
      else {
        return [
          ...acc,
          {
            guid: formType,
            name: formType
          }
        ]
      }

    }, []);
  }

  get critiqueFormTypes() {
    return this.props.settings.critiqueFormTypes ? this.props.settings.critiqueFormTypes : [];
  }

  onUpdateSettings(data) {
    this.props.updateDepartmentSettings({
      settings: {
        ...this.props.settings,
        ...data
      }
    })
      .then(() => {
        this.onCloseEditRatings();
      });
  }


  // ----------------------
  // Methods
  // ----------------------

  addToNotificationDistribution(roleScope) {
    const formData = {
      distribution: this.props.selectedNotification.getDistributionWithAdded(roleScope),
      notificationGuid: this.props.selectedNotificationGuid,
    };
    this.props.updateNotificationDistribution(formData);
  }

  removeFromNotificationDistribution(roleScope) {
    const formData = {
      distribution: this.props.selectedNotification.getDistributionWithRemoved(roleScope),
      notificationGuid: this.props.selectedNotificationGuid,
    };
    this.props.updateNotificationDistribution(formData);
  }

  saveRolesSettings(rolesSettings) {
    this.props.updateDepartmentSettings({
      settings: {
        ...this.props.settings,
        rolesSettings
      }
    })
      .then(() => {
      });
  }

  updateNewTaskResponse(e) {
    this.setState({
      newTaskResponse: e.target.value
    })
  }

  updateNewOitTaskResponse(e) {
    this.setState({
      newOitTaskResponse: e.target.value
    })
  }

  updateMainDepartment(form) {
    console.log('FORM', form)
    this.props.updateDepartmentSettings({
      settings: {
        ...this.props.settings,
        mainDepartment: form.mainDepartment
      }
    })
  }

  addNewTaskResponse() {
    if (!!this.state.newTaskResponse) {
      this.props.updateDepartmentSettings({
        settings: {
          ...this.props.settings,
          taskResponses: [...this.taskResponses, this.state.newTaskResponse.toLowerCase()]
        }
      })
        .then(() => {
          this.setState({
            newTaskResponse: ''
          })
        });

    }
  }

  addNewOitTaskResponse() {
    if (!!this.state.newOitTaskResponse) {
      this.props.updateDepartmentSettings({
        settings: {
          ...this.props.settings,
          oitTaskResponses: [...this.oitTaskResponses, this.state.newOitTaskResponse.toLowerCase()]
        }
      })
        .then(() => {
          this.setState({
            newOitTaskResponse: ''
          })
        });

    }
  }

  updateNewShift(e) {
    this.setState({
      newShift: e.target.value
    })
  }

  addNewShift() {
    if (!!this.state.newShift) {
      this.props.updateDepartmentSettings({
        settings: {
          ...this.props.settings,
          shifts: [...this.shifts, this.state.newShift.toLowerCase()]
        }
      })
        .then(() => {
          this.setState({
            newShift: ''
          })
        });
    }
  }

  removeTaskResponse(taskResponse) {
    this.props.updateDepartmentSettings({
      settings: {
        ...this.props.settings,
        taskResponses: this.taskResponses.filter(tr => tr !== taskResponse)
      }
    })
      .then(() => {
        this.setState({
          newTaskResponse: ''
        })
      });

  }

  removeOitTaskResponse(taskResponse) {
    this.props.updateDepartmentSettings({
      settings: {
        ...this.props.settings,
        oitTaskResponses: this.oitTaskResponses.filter(tr => tr !== taskResponse)
      }
    })
      .then(() => {
        this.setState({
          newOitTaskResponse: ''
        })
      });

  }

  removeShift(shift) {
    this.props.updateDepartmentSettings({
      settings: {
        ...this.props.settings,
        shifts: this.shifts.filter(tr => tr !== shift)
      }
    })
      .then(() => {
        this.setState({
          newShift: ''
        })
      });
  }

  isRiskAlertRoleSelected(role) {
    return this.props.settings.risk_alert_roles && this.props.settings.risk_alert_roles.includes(role)
  }

  isCritiqueFormRoleSelected(roleType) {
    if (this.props.settings.critiqueFormViewers) {
      const role = this.props.settings.critiqueFormViewers.find(role => role.type === roleType);
      if (role && !role.value) {
        return false;
      }
    }

    return true;
  }

  isAnalyticsViewRoleSelected(role) {
    return this.props.settings.analytics_roles && this.props.settings.analytics_roles.includes(role)
  }

  isSupervisorPermissionSelected(permission) {
    return !this.props.settings.supervisor_permissions || this.props.settings.supervisor_permissions[permission] !== false
  }

  canFtoViewCritiqueForm() {
    return this.props.settings && this.props.settings.can_fto_view_critique_form !== false
  }

  canFtoViewDepartmentFiles() {
    return this.props.settings && this.props.settings.allowOitToViewDepartmentFiles !== false
  }

  canFtoScheduleReports() {
    return this.props.settings && this.props.settings.allowFtoToScheduleReports !== false
  }

  canChangeFtoInSchedule() {
    return this.props.settings && this.props.settings.allowChangeFtoInSchedule;
  }

  areTestsDisabled() {
    return this.props.settings && this.props.settings.disableTests;
  }
  arePtoAnalyticsEnable() {
    return this.props.settings && this.props.settings.enablePtoAnalytics;
  }

  isOitAllowedToViewAnalytics() {
    return this.props.settings && this.props.settings.allowOitToViewAnalyticsReport;
  }

  onRoleSelect(e, role) {
    let riskAlertRoles = this.props.settings.risk_alert_roles || []
    if (e.target.checked) {
      riskAlertRoles = [...riskAlertRoles.filter(r => r !== role), role]
    } else {
      riskAlertRoles = riskAlertRoles.filter(r => r !== role)
    }

    this.props.updateDepartmentSettings({
      settings: {
        ...this.props.settings,
        risk_alert_roles: riskAlertRoles
      }
    })
  }

  onCritiqueFormRoleSelect(e, role) {
    let critiqueFormRoles = this.props.settings.critiqueFormViewers || [];
    critiqueFormRoles = [
      ...critiqueFormRoles.filter(r => r.type !== role),
      {
        type: role,
        value: e.target.checked
      }
    ]

    this.props.updateDepartmentSettings({
      settings: {
        ...this.props.settings,
        critiqueFormViewers: critiqueFormRoles,
        can_fto_view_critique_form: role === 'fto' ? e.target.checked : this.props.settings.can_fto_view_critique_form
      }
    })
  }

  onAnayiticsRoleSelected(e, role) {
    let analytics_roles = this.props.settings.analytics_roles || []
    if (e.target.checked) {
      analytics_roles = [...analytics_roles.filter(r => r !== role), role]
    } else {
      analytics_roles = analytics_roles.filter(r => r !== role)
    }

    this.props.updateDepartmentSettings({
      settings: {
        ...this.props.settings,
        analytics_roles: analytics_roles
      }
    })
  }

  onSupervisorPermissionSelected(e, permission) {
    let supervisor_permissions = this.props.settings.supervisor_permissions || {}
    if (e.target.checked) {
      supervisor_permissions[permission] = true
    } else {
      supervisor_permissions[permission] = false
    }

    this.props.updateDepartmentSettings({
      settings: {
        ...this.props.settings,
        supervisor_permissions: supervisor_permissions
      }
    })
  }

  addFormType(formType) {
    this.props.updateDepartmentSettings({
      settings: {
        ...this.props.settings,
        critiqueFormTypes: [
          ...this.critiqueFormTypes,
          formType.guid
        ]
      }
    })
  }

  onCanFtoViewCritiqueForm(e) {
    let critiqueFormRoles = this.props.settings.critiqueFormViewers || [];
    critiqueFormRoles = [
      ...critiqueFormRoles.filter(r => r.type !== 'fto'),
      {
        type: 'fto',
        value: e.target.checked
      }
    ]

    this.props.updateDepartmentSettings({
      settings: {
        ...this.props.settings,
        can_fto_view_critique_form: e.target.checked,
        critiqueFormViewers: critiqueFormRoles,
      }
    })
  }

  onCanFtoViewDepartmentFiles(e) {
    this.props.updateDepartmentSettings({
      settings: {
        ...this.props.settings,
        allowOitToViewDepartmentFiles: e.target.checked
      }
    })
  }
  onUpdateShowCommentsForFto(e) {
    this.props.updateDepartmentSettings({
      settings: {
        ...this.props.settings,
        showCommentsForFto: e.target.checked
      }
    })
  }

  onCanFtoScheduleReports(e) {
    this.props.updateDepartmentSettings({
      settings: {
        ...this.props.settings,
        allowFtoToScheduleReports: e.target.checked
      }
    })
  }

  onCanChangeFtoInSchedule(e) {
    this.props.updateDepartmentSettings({
      settings: {
        ...this.props.settings,
        allowChangeFtoInSchedule: e.target.checked
      }
    })
  }


  onAreDisabledTestsChange(e) {
    this.props.updateDepartmentSettings({
      settings: {
        ...this.props.settings,
        disableTests: e.target.checked
      }
    })
  }

  onEnablePtoAnalyticsChange(e) {
    this.props.updateDepartmentSettings({
      settings: {
        ...this.props.settings,
        enablePtoAnalytics: e.target.checked
      }
    })
  }

  onIsOitAllowedToViewAnalyticsReportChange(e) {
    this.props.updateDepartmentSettings({
      settings: {
        ...this.props.settings,
        allowOitToViewAnalyticsReport: e.target.checked
      }
    })
  }

  removeFormType(formType) {
    const critiqueFormTypes = this.critiqueFormTypes.filter((cFormType) => cFormType !== formType);

    this.props.updateDepartmentSettings({
      settings: {
        ...this.props.settings,
        critiqueFormTypes: critiqueFormTypes
      }
    })
  }

  saveBadge(badgeUrl) {
    this.props.updateDepartmentSettings({
      settings: {
        ...this.props.settings,
        departmentBadge: badgeUrl
      }
    })
  }
  //----------------------
  // ANALYTICS DEFAULT FORM TYPES
  //----------------------


  addFormType(settingsKey, formType) {
    this.props.updateDepartmentSettings({
      settings: {
        ...this.props.settings,
        [settingsKey]: [
          ...this.getAnalyticsFormTypes(settingsKey),
          formType.guid
        ]
      }
    })
  }

  removeFormType(settingsKey, formType) {
    const formTypes = this.getAnalyticsFormTypes(settingsKey).filter((cFormType) => cFormType !== formType);

    this.props.updateDepartmentSettings({
      settings: {
        ...this.props.settings,
        [settingsKey]: formTypes
      }
    })
  }

  getAnalyticsFormTypes(settingsKey) {
    return this.props.settings[settingsKey] ? this.props.settings[settingsKey] : [];
  }

  getFormTypes(settingsKey) {

    return this.props.formTypes.reduce((acc, {short: formType}) => {

      const isAdded = this.getAnalyticsFormTypes(settingsKey).find((cformType) => cformType === formType);

      if (isAdded) {
        return [
          ...acc
        ]
      }
      else {
        return [
          ...acc,
          {
            guid: formType,
            name: formType
          }
        ]
      }

    }, []);
  }


  // ----------------------
  // Render
  // ----------------------

  render() {
    return (
      <LoadingOverlay isLoading={this.isLoading}>
        {!this.isLoading &&
        <Fragment>

          <div className="app-content-header">
            <h4 className="title">Department Settings</h4>
          </div>

          <div className="app-content department-settings">
            <ListActionSubheader title="Department Badge">
            </ListActionSubheader>
            <Card className="department-settings-details">
              <UploadBadge
                badgePhoto={this.props.settings.departmentBadge}
                onSaveBadge={(badgeUrl) => this.saveBadge(badgeUrl)}
              />
            </Card>

            <ListActionSubheader title=" Main department name">
            </ListActionSubheader>
            <Card className="department-settings-details">
              <CustomForm config={MainDepartmentNameForm} initialValues={this.props.settings}
                          onSubmit={(form) => this.updateMainDepartment(form)}/>
            </Card>


            <ListActionSubheader title="Ratings">
              <EditActionButton label="Ratings" onEdit={() => this.onEditRatings()}/>
            </ListActionSubheader>
            <Card className="department-settings-details">
              <div className="department-settings-details-item">
                <div className="property">
                  <span className="property__label">Risk Alert Limit</span>
                  <span className="property__value">At or below {this.props.settings.riskAlert} <i
                    className="fa fa-star"/> on a scale of 1 to {this.props.settings.scale}</span>
                </div>
              </div>
              <div className="department-settings-details-item">
                <FormattedProperty
                  label="Rating Maximum"
                  value={this.props.settings.scale}
                />
              </div>
            </Card>
            <ListActionSubheader title="Roles settings">
            </ListActionSubheader>
            <Card className="department-settings-details">
              <CustomForm config={RolesSettingsForm} initialValues={this.rolesSettings}
                          onSubmit={(form) => this.saveRolesSettings(form)}/>
            </Card>
            <ListActionSubheader title="Available task responses, default: Explained, Demonstrated, Practiced">
            </ListActionSubheader>
            <Card className="fto-guidelines form">
              <div className="form-group">
                <label>
                  Task response
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={this.state.newTaskResponse}
                  onChange={(e) => this.updateNewTaskResponse(e)}
                />
                <AddActionButton label="Task Response" onAdd={() => this.addNewTaskResponse()}/>
              </div>
              <div className="available-task-responses">
                {this.taskResponses.map(response =>
                  <div className="available-task-response" onClick={() => this.removeTaskResponse(response)}>
                    <i className="fa fa-close"/>
                    {response}
                  </div>)}
              </div>

              <div className="form-group">
                <label>
                  {this.rolesSettings.oit_short || 'OIT'} Task responses
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={this.state.newOitTaskResponse}
                  onChange={(e) => this.updateNewOitTaskResponse(e)}
                />
                <AddActionButton label="Task Response" onAdd={() => this.addNewOitTaskResponse()}/>
              </div>
              <div className="available-task-responses">
                {this.oitTaskResponses.map(response =>
                  <div className="available-task-response" onClick={() => this.removeOitTaskResponse(response)}>
                    <i className="fa fa-close"/>
                    {response}
                  </div>)}
              </div>
            </Card>
            <ListActionSubheader title="Available shifts, default: ">
            </ListActionSubheader>
            <Card className="fto-guidelines form">
              <div className="form-group">
                <label>
                  Shifts
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={this.state.newShift}
                  onChange={(e) => this.updateNewShift(e)}
                />
                <AddActionButton label="Shift" onAdd={() => this.addNewShift()}/>
              </div>
              <div className="available-task-responses">
                {this.shifts.map(shift =>
                  <div className="available-task-response" onClick={() => this.removeShift(shift)}
                       style={{textTransform: 'capitalize'}}>
                    <i className="fa fa-close"/>
                    {shift}
                  </div>)}
              </div>
            </Card>
            <ListActionSubheader title="Risk alert roles">
            </ListActionSubheader>
            <Card className="risk-alert-roles">
              {/*<Checkbox checked={this.isRiskAlertRoleSelected('fto')}  onChange={e => this.onRoleSelect(e, 'fto')} label={this.props.ftoLabel}/>*/}
              <Checkbox checked={this.isRiskAlertRoleSelected('ftoc')} onChange={e => this.onRoleSelect(e, 'ftoc')}
                        label={this.props.ftocLabel}/>
              <Checkbox checked={this.isRiskAlertRoleSelected('sup')} onChange={e => this.onRoleSelect(e, 'sup')}
                        label={this.props.supLabel}/>
              <Checkbox checked={this.isRiskAlertRoleSelected('cstaff')} onChange={e => this.onRoleSelect(e, 'cstaff')}
                        label={this.props.cstaffLabel}/>
              <Checkbox checked={this.isRiskAlertRoleSelected('chief')} onChange={e => this.onRoleSelect(e, 'chief')}
                        label={this.props.chiefLabel}/>
              <Checkbox checked={this.isRiskAlertRoleSelected('depadmin')}
                        onChange={e => this.onRoleSelect(e, 'depadmin')} label="Department admin"/>
            </Card>

            <ListActionSubheader title="Critique form roles">
            </ListActionSubheader>
            <Card className="risk-alert-roles">
              <Checkbox checked={this.isCritiqueFormRoleSelected('fto')}  onChange={e => this.onCritiqueFormRoleSelect(e, 'fto')}
                        label={this.props.ftoLabel}/>
              <Checkbox checked={this.isCritiqueFormRoleSelected('ftoc')} onChange={e => this.onCritiqueFormRoleSelect(e, 'ftoc')}
                        label={this.props.ftocLabel}/>
              <Checkbox checked={this.isCritiqueFormRoleSelected('sup')} onChange={e => this.onCritiqueFormRoleSelect(e, 'sup')}
                        label={this.props.supLabel}/>
              <Checkbox checked={this.isCritiqueFormRoleSelected('cstaff')} onChange={e => this.onCritiqueFormRoleSelect(e, 'cstaff')}
                        label={this.props.cstaffLabel}/>
              <Checkbox checked={this.isCritiqueFormRoleSelected('chief')} onChange={e => this.onCritiqueFormRoleSelect(e, 'chief')}
                        label={this.props.chiefLabel}/>
            </Card>

            <ListActionSubheader title="Analytics report roles">
            </ListActionSubheader>
            <Card className="risk-alert-roles">
              <Checkbox checked={this.isAnalyticsViewRoleSelected('fto')}
                        onChange={e => this.onAnayiticsRoleSelected(e, 'fto')} label={this.props.ftoLabel}/>
              <Checkbox checked={this.isAnalyticsViewRoleSelected('cstaff')}
                        onChange={e => this.onAnayiticsRoleSelected(e, 'cstaff')}
                        label={this.props.cstaffLabel}/>

              <Checkbox checked={this.isAnalyticsViewRoleSelected('chief')}
                        onChange={e => this.onAnayiticsRoleSelected(e, 'chief')}
                        label={this.props.chiefLabel}/>
              <Checkbox checked={this.isAnalyticsViewRoleSelected('depadmin')}
                        onChange={e => this.onAnayiticsRoleSelected(e, 'depadmin')} label="Department admin"/>
            </Card>
            <ListActionSubheader title="Supervisor permissions">
            </ListActionSubheader>
            <Card className="risk-alert-roles">
              <Checkbox checked={this.isSupervisorPermissionSelected('review_open_reports')}
                        onChange={e => this.onSupervisorPermissionSelected(e, 'review_open_reports')}
                        label="Review open reports"/>
              <Checkbox checked={this.isSupervisorPermissionSelected('assign_schedules')}
                        onChange={e => this.onSupervisorPermissionSelected(e, 'assign_schedules')}
                        label="Assign schedules"/>
              <Checkbox checked={this.isSupervisorPermissionSelected('observation_analytics')}
                        onChange={e => this.onSupervisorPermissionSelected(e, 'observation_analytics')}
                        label="Observation Analytics"/>
              <Checkbox checked={this.isSupervisorPermissionSelected('view_late_fto_notifications')}
                        onChange={e => this.onSupervisorPermissionSelected(e, 'view_late_fto_notifications')}
                        label={`View Late ${this.props.ftoLabel} Notifications`}/>
              <Checkbox checked={this.isSupervisorPermissionSelected('view_late_oit_acknowledgement')}
                        onChange={e => this.onSupervisorPermissionSelected(e, 'view_late_oit_acknowledgement')}
                        label={`View Late ${this.props.oitLabel} Acknowledgement`}/>
              <Checkbox checked={this.isSupervisorPermissionSelected('view_task_progress')}
                        onChange={e => this.onSupervisorPermissionSelected(e, 'view_task_progress')}
                        label={`View task progress`}/>
            </Card>
            <ListActionSubheader title={`${this.props.ftoLabel} view of Critique form`}>
            </ListActionSubheader>
            <Card className="risk-alert-roles">
              <Checkbox checked={this.canFtoViewCritiqueForm()}
                        onChange={e => this.onCanFtoViewCritiqueForm(e)}
                        label={`Allow ${this.props.ftoLabel} to view critique form`}/>
            </Card>
            <ListActionSubheader title={`Can ${this.props.ftoLabel} view of comments for ${this.props.oitLabel}`}>
            </ListActionSubheader>
            <Card className="risk-alert-roles">
              <Checkbox checked={this.props.settings.showCommentsForFto}
                        onChange={e => this.onUpdateShowCommentsForFto(e)}
                        label={`Allow ${this.props.ftoLabel} view of comments for ${this.props.oitLabel}`}/>
            </Card>

            <Card className="form-types">
              <div className="all">
                <p>Critique form types</p>
                <Select
                  value={null}
                  placeholder={'Add Form Type'}
                  icon={' '}
                  items={this.formTypes}
                  onSelect={formType => this.addFormType('critiqueFormTypes', formType)}
                />
              </div>

              <div className="added">
                <p>Added Form Types</p>
                {this.getAnalyticsFormTypes('critiqueFormTypes').map(formType =>
                  <div className="available-task-response">
                    <span>
                      {formType}
                    </span>

                    <i className="fa fa-close" onClick={() => this.removeFormType('critiqueFormTypes', formType)}/>
                  </div>)
                }
              </div>
            </Card>

            <Card className="form-types">
              <div className="all">
                <p>Log occurrences default form types</p>
                <Select
                  value={null}
                  placeholder={'Add Form Type'}
                  icon={' '}
                  items={this.getFormTypes('logOccurrenceFormTypes')}
                  onSelect={formType => this.addFormType('logOccurrenceFormTypes', formType)}
                />
              </div>

              <div className="added">
                <p>Added Form Types</p>
                {this.getAnalyticsFormTypes('logOccurrenceFormTypes').map(formType =>
                  <div className="available-task-response">
                    <span>
                      {formType}
                    </span>

                    <i className="fa fa-close" onClick={() => this.removeFormType('logOccurrenceFormTypes', formType)}/>
                  </div>)
                }
              </div>
            </Card>

            <Card className="form-types">
              <div className="all">
                <p>Oit analytics default form types</p>
                <Select
                  value={null}
                  placeholder={'Add Form Type'}
                  icon={' '}
                  items={this.getFormTypes('oitAnalyticsFormTypes')}
                  onSelect={formType => this.addFormType('oitAnalyticsFormTypes', formType)}
                />
              </div>

              <div className="added">
                <p>Added Form Types</p>
                {this.getAnalyticsFormTypes('oitAnalyticsFormTypes').map(formType =>
                  <div className="available-task-response">
                    <span>
                      {formType}
                    </span>

                    <i className="fa fa-close" onClick={() => this.removeFormType('oitAnalyticsFormTypes', formType)}/>
                  </div>)
                }
              </div>
            </Card>
            <Card className="form-types">
              <div className="all">
                <p>Oit statistics default form types</p>
                <Select
                  value={null}
                  placeholder={'Add Form Type'}
                  icon={' '}
                  items={this.getFormTypes('oitStatisticsFormTypes')}
                  onSelect={formType => this.addFormType('oitStatisticsFormTypes', formType)}
                />
              </div>

              <div className="added">
                <p>Added Form Types</p>
                {this.getAnalyticsFormTypes('oitStatisticsFormTypes').map(formType =>
                  <div className="available-task-response">
                    <span>
                      {formType}
                    </span>

                    <i className="fa fa-close" onClick={() => this.removeFormType('oitStatisticsFormTypes', formType)}/>
                  </div>)
                }
              </div>
            </Card>
            <Card className="form-types">
              <div className="all">
                <p>Fto statistics default form types</p>
                <Select
                  value={null}
                  placeholder={'Add Form Type'}
                  icon={' '}
                  items={this.getFormTypes('ftoStatisticsFormTypes')}
                  onSelect={formType => this.addFormType('ftoStatisticsFormTypes', formType)}
                />
              </div>

              <div className="added">
                <p>Added Form Types</p>
                {this.getAnalyticsFormTypes('ftoStatisticsFormTypes').map(formType =>
                  <div className="available-task-response">
                    <span>
                      {formType}
                    </span>

                    <i className="fa fa-close" onClick={() => this.removeFormType('ftoStatisticsFormTypes', formType)}/>
                  </div>)
                }
              </div>
            </Card>

            <ListActionSubheader title={`${this.props.oitLabel} view of Department files`}>
            </ListActionSubheader>
            <Card className="risk-alert-roles">
              <Checkbox checked={this.canFtoViewDepartmentFiles()}
                        onChange={e => this.onCanFtoViewDepartmentFiles(e)}
                        label={`Allow ${this.props.oitLabel} to view department files`}/>
            </Card>
            <ListActionSubheader title={`${this.props.ftoLabel} view of Assign Schedules`}>
            </ListActionSubheader>
            <Card className="risk-alert-roles">
              <Checkbox checked={this.canFtoScheduleReports()}
                        onChange={e => this.onCanFtoScheduleReports(e)}
                        label={`Allow ${this.props.ftoLabel} to schedule reports`}/>
            </Card>
            <ListActionSubheader title={`${this.props.ftoLabel} change in schedule`}>
            </ListActionSubheader>
            <Card className="risk-alert-roles">
              <Checkbox checked={this.canChangeFtoInSchedule()}
                        onChange={e => this.onCanChangeFtoInSchedule(e)}
                        label={`Allow ${this.props.ftoLabel} change in schedule`}/>
            </Card>
            <ListActionSubheader title="Disable tests">
            </ListActionSubheader>
            <Card className="risk-alert-roles">
              <Checkbox checked={this.areTestsDisabled()}
                        onChange={e => this.onAreDisabledTestsChange(e)}
                        label={`Disable tests for department`}/>
            </Card>
            <ListActionSubheader title="Disable tests">
            </ListActionSubheader>
            <Card className="risk-alert-roles">
              <Checkbox checked={this.arePtoAnalyticsEnable()}
                        onChange={e => this.onEnablePtoAnalyticsChange(e)}
                        label={`Enable PTO analytics`}/>
            </Card>
            <ListActionSubheader title={`Allow ${this.props.oitLabel} to view analytics`}>
            </ListActionSubheader>
            <Card className="risk-alert-roles">
              <Checkbox checked={this.isOitAllowedToViewAnalytics()}
                        onChange={e => this.onIsOitAllowedToViewAnalyticsReportChange(e)}
                        label={`Allow ${this.props.oitLabel} to view analytics report for his scores`}/>
            </Card>
            <ListActionSubheader title={`${this.props.ftoShortLabel} Scoring Guidelines`}>
            </ListActionSubheader>
            <Card className="fto-guidelines">
              <UploadFTOGuidelines
                settings={this.props.settings}
                onUpdateSettings={(data) => this.onUpdateSettings(data)}/>
            </Card>

          </div>

          <Modal
            isOpen={this.state.isEditingRatings}
            title="Edit ratings"
            onClose={() => this.onCloseEditRatings()}>
            <DepartmentSettingsEdit
              isLoading={this.isDepartmentSettingsEditLoading}
              settings={this.props.settings}
              onSave={formData => this.onSaveEditRatings(formData)}
            />
          </Modal>

          <Modal
            isOpen={!!this.isShowingNotification}
            title="Notification"
            onClose={() => this.props.setSelectedNotification(null)}>
            {this.isShowingNotification &&
            <NotificationDetail
              notification={this.props.selectedNotification}
              isNotificationDistributionLoading={this.isNotificationDistributionLoading}
              onAddToDistribution={(roleScope) => {
                return this.addToNotificationDistribution(roleScope);
              }}

              onEdit={() => this.props.editNotification()}
              onRemoveFromDistribution={(roleScope) => {
                return this.removeFromNotificationDistribution(roleScope);
              }}
            />
            }
          </Modal>

          <Modal
            isOpen={this.props.isEditingNotification}
            onClose={() => this.props.closeEditNotification()}
            title="Edit Notification">
            {this.props.isEditingNotification &&
            <NotificationEdit
              isLoading={this.isEditNotificationLoading}
              onSave={formData => this.onSaveEditNotificationDetails(formData)}
              notification={this.props.selectedNotification}
            />
            }
          </Modal>
        </Fragment>
        }
      </LoadingOverlay>
    );
  }
}

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {
    isEditingNotification: state.departmentSettings.isEditingNotification,
    isLoading: state.departmentSettings.isLoading,
    notifications: state.departmentSettings.notifications,
    settings: state.departmentSettings.settings,
    selectedNotification: departmentSettingsSelectors.selectedNotification(state),
    selectedNotificationGuid: state.departmentSettings.selectedNotificationGuid,
    ftoShortLabel: departmentSettingsSelectors.ftoShortLabel(state),
    ftoLabel: departmentSettingsSelectors.ftoLabel(state),
    ftocLabel: departmentSettingsSelectors.ftocLabel(state),
    supLabel: departmentSettingsSelectors.supLabel(state),
    cstaffLabel: departmentSettingsSelectors.cstaffLabel(state),
    chiefLabel: departmentSettingsSelectors.chiefLabel(state),
    oitLabel: departmentSettingsSelectors.oitShortLabel(state),
    formTypes: state.common.formTypes
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    closeEditNotification: () => {
      return dispatch(departmentSettingsActionsCreators.closeEditNotification());
    },
    editNotification: () => {
      return dispatch(departmentSettingsActionsCreators.editNotification());
    },
    loadDepartmentSettings: () => {
      dispatch(departmentSettingsActionsCreators.loadDepartmentSettings());
    },
    setSelectedNotification: (notificationGuid) => {
      dispatch(departmentSettingsActionsCreators.setSelectedNotification(notificationGuid));
    },
    updateDepartmentSettings: (formData) => {
      return dispatch(departmentSettingsActionsCreators.updateDepartmentSettings(formData));
    },
    updateNotification: (notificationGuid, formData) => {
      return dispatch(departmentSettingsActionsCreators.updateNotification(notificationGuid, formData));
    },
    updateNotificationDistribution: (formData) => {
      dispatch(departmentSettingsActionsCreators.updateDistribution(formData));
    },
    fetchFormTypes: () => dispatch(commonActionCreators.fetchFormTypes())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DepartmentSettings);
